import type { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BooleanType: { input: any; output: any; }
  CustomData: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FloatType: { input: any; output: any; }
  IntType: { input: any; output: any; }
  ItemId: { input: any; output: any; }
  JsonField: { input: any; output: any; }
  MetaTagAttributes: { input: any; output: any; }
  UploadId: { input: any; output: any; }
};

/** Linking fields */
export enum AlumniPageModelFieldsReferencingDownloadCategoryModel {
  AlumniPage_contentModules = 'alumniPage_contentModules',
  AlumniPage_contentModules__contentDownloadOverview_downloadCategories = 'alumniPage_contentModules__contentDownloadOverview_downloadCategories'
}

export type AlumniPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AlumniPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AlumniPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  isPagePublic?: InputMaybe<BooleanFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum AlumniPageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  IsPagePublic_ASC = 'isPagePublic_ASC',
  IsPagePublic_DESC = 'isPagePublic_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export enum ColorBucketType {
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export type ContactModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContactModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContactModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  groupName?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  teamPhoto?: InputMaybe<FileFilter>;
  text?: InputMaybe<StructuredTextFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum ContactModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  GroupName_ASC = 'groupName_ASC',
  GroupName_DESC = 'groupName_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter Date fields */
export type DateFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['Date']['input']>;
};

export type DepartmentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DepartmentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DepartmentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
};

export enum DepartmentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC'
}

export type DownloadCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DownloadCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DownloadCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  category?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
};

export enum DownloadCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Category_ASC = 'category_ASC',
  Category_DESC = 'category_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC'
}

/** Linking fields */
export enum DownloadModelFieldsReferencingDownloadCategoryModel {
  Download_category = 'download_category'
}

export type DownloadModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DownloadModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DownloadModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  category?: InputMaybe<LinkFilter>;
  document?: InputMaybe<FileFilter>;
  documentTitle?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
};

export enum DownloadModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  DocumentTitle_ASC = 'documentTitle_ASC',
  DocumentTitle_DESC = 'documentTitle_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC'
}

export enum FaviconType {
  AppleTouchIcon = 'appleTouchIcon',
  Icon = 'icon',
  MsApplication = 'msApplication'
}

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  Compress = 'compress',
  Enhance = 'enhance',
  Format = 'format',
  Redeye = 'redeye'
}

export enum ImgixParamsBgRemoveFgType {
  Auto = 'auto',
  Car = 'car'
}

export enum ImgixParamsBlendAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendCrop {
  Bottom = 'bottom',
  Faces = 'faces',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsBlendMode {
  Burn = 'burn',
  Color = 'color',
  Darken = 'darken',
  Difference = 'difference',
  Dodge = 'dodge',
  Exclusion = 'exclusion',
  Hardlight = 'hardlight',
  Hue = 'hue',
  Lighten = 'lighten',
  Luminosity = 'luminosity',
  Multiply = 'multiply',
  Normal = 'normal',
  Overlay = 'overlay',
  Saturation = 'saturation',
  Screen = 'screen',
  Softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  Inherit = 'inherit'
}

export enum ImgixParamsCh {
  Dpr = 'dpr',
  SaveData = 'saveData',
  Width = 'width'
}

export enum ImgixParamsCrop {
  Bottom = 'bottom',
  Edges = 'edges',
  Entropy = 'entropy',
  Faces = 'faces',
  Focalpoint = 'focalpoint',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsCs {
  Adobergb1998 = 'adobergb1998',
  Origin = 'origin',
  Srgb = 'srgb',
  Strip = 'strip',
  Tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  Blur = 'blur',
  Gen = 'gen',
  Generative = 'generative',
  Gradient = 'gradient',
  Solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientCs {
  Hsl = 'hsl',
  Lch = 'lch',
  Linear = 'linear',
  Oklab = 'oklab',
  Srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientType {
  Linear = 'linear',
  Radial = 'radial'
}

export enum ImgixParamsFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Facearea = 'facearea',
  Fill = 'fill',
  Fillmax = 'fillmax',
  Max = 'max',
  Min = 'min',
  Scale = 'scale'
}

export enum ImgixParamsFlip {
  H = 'h',
  Hv = 'hv',
  V = 'v'
}

export enum ImgixParamsFm {
  Avif = 'avif',
  Blurhash = 'blurhash',
  Gif = 'gif',
  Jp2 = 'jp2',
  Jpg = 'jpg',
  Json = 'json',
  Jxr = 'jxr',
  Mp4 = 'mp4',
  Pjpg = 'pjpg',
  Png = 'png',
  Png8 = 'png8',
  Png32 = 'png32',
  Webm = 'webm',
  Webp = 'webp'
}

export enum ImgixParamsIptc {
  Allow = 'allow',
  Block = 'block'
}

export enum ImgixParamsMarkAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsMarkFit {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsMarkTile {
  Grid = 'grid'
}

export enum ImgixParamsPalette {
  Css = 'css',
  Json = 'json'
}

export enum ImgixParamsRotType {
  Pivot = 'pivot',
  Straighten = 'straighten'
}

export enum ImgixParamsTransparency {
  Grid = 'grid'
}

export enum ImgixParamsTrim {
  Alpha = 'alpha',
  Auto = 'auto',
  Color = 'color'
}

export enum ImgixParamsTxtAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsTxtClip {
  Ellipsis = 'ellipsis',
  End = 'end',
  Middle = 'middle',
  Start = 'start'
}

export enum ImgixParamsTxtFit {
  Max = 'max'
}

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenAlumniPageAndDownloadCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<AlumniPageModelFieldsReferencingDownloadCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<AlumniPageModelFieldsReferencingDownloadCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenDownloadAndDownloadCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<DownloadModelFieldsReferencingDownloadCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<DownloadModelFieldsReferencingDownloadCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenNewsAndDownloadCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<NewsModelFieldsReferencingDownloadCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<NewsModelFieldsReferencingDownloadCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenPageAndDownloadCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<PageModelFieldsReferencingDownloadCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<PageModelFieldsReferencingDownloadCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenSchuelerblogAndDownloadCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<SchuelerblogModelFieldsReferencingDownloadCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<SchuelerblogModelFieldsReferencingDownloadCategoryModel>>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenAlumniPageAndDownloadCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenAlumniPageAndDownloadCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenDownloadAndDownloadCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenDownloadAndDownloadCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenNewsAndDownloadCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenNewsAndDownloadCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenPageAndDownloadCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenPageAndDownloadCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenSchuelerblogAndDownloadCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenSchuelerblogAndDownloadCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated'
}

export type JobModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<JobModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<JobModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  contactPerson?: InputMaybe<LinkFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pensum?: InputMaybe<StringFilter>;
  testimonials?: InputMaybe<LinksFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum JobModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Pensum_ASC = 'pensum_ASC',
  Pensum_DESC = 'pensum_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Linking locales */
export enum LinkingLocale {
  _nonLocalized = '_nonLocalized',
  De = 'de',
  En = 'en'
}

/** Specifies how to filter by linking locales */
export type LinkingLocalesFilter = {
  /** Filter linking records that link to current record in at least one of the specified locales */
  anyIn?: InputMaybe<Array<LinkingLocale>>;
  /** Filter linking records that do not link to current record in any of the specified locales */
  notIn?: InputMaybe<Array<LinkingLocale>>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Specifies how to filter by locale */
export type LocalesFilter = {
  /** Filter records that are localized in all the specified locales */
  allIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are localized in at least one of the specified locales */
  anyIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are not localized in any of the specified locales */
  notIn?: InputMaybe<Array<SiteLocale>>;
};

export enum MuxThumbnailFitMode {
  Crop = 'crop',
  Pad = 'pad',
  Preserve = 'preserve',
  Smartcrop = 'smartcrop',
  Stretch = 'stretch'
}

export enum MuxThumbnailFormatType {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png'
}

export enum MuxThumbnailRotation {
  /** Rotate 90° clockwise */
  ROTATE_90 = 'ROTATE_90',
  /** Rotate 180° clockwise */
  ROTATE_180 = 'ROTATE_180',
  /** Rotate 270° clockwise */
  ROTATE_270 = 'ROTATE_270'
}

/** Linking fields */
export enum NewsModelFieldsReferencingDownloadCategoryModel {
  News_contentModules = 'news_contentModules',
  News_contentModules__contentDownloadOverview_downloadCategories = 'news_contentModules__contentDownloadOverview_downloadCategories'
}

export type NewsModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<NewsModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<LinkFilter>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum NewsModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Date_ASC = 'date_ASC',
  Date_DESC = 'date_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

/** Linking fields */
export enum PageModelFieldsReferencingDownloadCategoryModel {
  Page_contentModules = 'page_contentModules',
  Page_contentModules__contentDownloadOverview_downloadCategories = 'page_contentModules__contentDownloadOverview_downloadCategories'
}

export type PageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  canonicalUrl?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum PageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter by parent (tree-like collections only) */
export type ParentFilter = {
  /** Filter records children of the specified record. Value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with a parent record or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

/** Linking fields */
export enum SchuelerblogModelFieldsReferencingDownloadCategoryModel {
  Schuelerblog_contentModules = 'schuelerblog_contentModules',
  Schuelerblog_contentModules__contentDownloadOverview_downloadCategories = 'schuelerblog_contentModules__contentDownloadOverview_downloadCategories'
}

export type SchuelerblogModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SchuelerblogModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SchuelerblogModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<LinkFilter>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  translatedSlug?: InputMaybe<SlugFilter>;
};

export enum SchuelerblogModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Date_ASC = 'date_ASC',
  Date_DESC = 'date_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export enum SiteLocale {
  De = 'de',
  En = 'en'
}

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TeamMemberModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeamMemberModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TeamMemberModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<BooleanFilter>;
  departments?: InputMaybe<LinksFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  eMail?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  lastname?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  role?: InputMaybe<StringFilter>;
  teams?: InputMaybe<LinksFilter>;
};

export enum TeamMemberModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Author_ASC = 'author_ASC',
  Author_DESC = 'author_DESC',
  EMail_ASC = 'eMail_ASC',
  EMail_DESC = 'eMail_DESC',
  Firstname_ASC = 'firstname_ASC',
  Firstname_DESC = 'firstname_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Lastname_ASC = 'lastname_ASC',
  Lastname_DESC = 'lastname_DESC',
  Phone_ASC = 'phone_ASC',
  Phone_DESC = 'phone_DESC',
  Role_ASC = 'role_ASC',
  Role_DESC = 'role_DESC'
}

export type TeamModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeamModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TeamModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
};

export enum TeamModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC'
}

export type TestimonialModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TestimonialModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TestimonialModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  portrait?: InputMaybe<FileFilter>;
  quote?: InputMaybe<StructuredTextFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum TestimonialModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  path?: InputMaybe<UploadPathFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Basename_ASC = 'basename_ASC',
  Basename_DESC = 'basename_DESC',
  Filename_ASC = 'filename_ASC',
  Filename_DESC = 'filename_DESC',
  Format_ASC = 'format_ASC',
  Format_DESC = 'format_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MimeType_ASC = 'mimeType_ASC',
  MimeType_DESC = 'mimeType_DESC',
  Resolution_ASC = 'resolution_ASC',
  Resolution_DESC = 'resolution_DESC',
  Size_ASC = 'size_ASC',
  Size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

/** Specifies how to filter by path */
export type UploadPathFilter = {
  /** Search the asset with the specified path */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified paths */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified path */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified paths */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  Archive = 'archive',
  Audio = 'audio',
  Image = 'image',
  Pdfdocument = 'pdfdocument',
  Presentation = 'presentation',
  Richtext = 'richtext',
  Spreadsheet = 'spreadsheet',
  Video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export enum VideoMp4Res {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

type ContentModules_ContentAccordionRecord_Fragment = { __typename: 'ContentAccordionRecord', id: any, title?: string | null, items: Array<{ id: any, title?: string | null, text?: { value: any } | null }> };

type ContentModules_ContentDepartmentRecord_Fragment = { __typename: 'ContentDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }> };

type ContentModules_ContentDownloadOverviewRecord_Fragment = { __typename: 'ContentDownloadOverviewRecord', id: any, title?: string | null, downloadCategories: Array<{ id: any, category?: string | null, _allReferencingDownloads: Array<{ id: any, documentTitle?: string | null, document?: { title?: string | null, filename: string, url: string } | null }> }> };

type ContentModules_ContentDownloadRecord_Fragment = { __typename: 'ContentDownloadRecord', id: any, title?: string | null, documents: Array<{ title?: string | null, filename: string, url: string }> };

type ContentModules_ContentImageRecord_Fragment = { __typename: 'ContentImageRecord', id: any, display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

type ContentModules_ContentImagesliderRecord_Fragment = { __typename: 'ContentImagesliderRecord', id: any, images: Array<{ display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> };

type ContentModules_ContentImagetextRecord_Fragment = { __typename: 'ContentImagetextRecord', id: any, title?: string | null, leadText?: string | null, imagePlacement?: string | null, text?: { value: any } | null, cta?: { id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

type ContentModules_ContentNewsRecord_Fragment = { __typename: 'ContentNewsRecord', id: any, title?: string | null, lead?: { value: any } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> };

type ContentModules_ContentNewssliderRecord_Fragment = { __typename: 'ContentNewssliderRecord', id: any, title?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'SchuelerblogRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> };

type ContentModules_ContentRegistrationprocessRecord_Fragment = { __typename: 'ContentRegistrationprocessRecord', id: any, title?: string | null, steps: Array<{ title?: string | null, id: any, text?: { value: any } | null }> };

type ContentModules_ContentTeacherDepartmentRecord_Fragment = { __typename: 'ContentTeacherDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }>, teachers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> };

type ContentModules_ContentTeamRecord_Fragment = { __typename: 'ContentTeamRecord', id: any, title?: string | null, teams: Array<{ id: any, name?: string | null }>, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> };

type ContentModules_ContentTeammemberRecord_Fragment = { __typename: 'ContentTeammemberRecord', id: any, title?: string | null, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> };

type ContentModules_ContentTeaserRecord_Fragment = { __typename: 'ContentTeaserRecord', id: any, title?: string | null, lead?: { value: any } | null, teaser: Array<{ __typename: 'TeaserBigRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserHomeRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserSmallRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null }> };

type ContentModules_ContentTestimonialRecord_Fragment = { __typename: 'ContentTestimonialRecord', id: any, name?: string | null, title?: string | null, role?: string | null, statement?: { value: any } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

type ContentModules_ContentTextRecord_Fragment = { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null };

type ContentModules_ContentVideoRecord_Fragment = { __typename: 'ContentVideoRecord', id: any, videoType: any, videoCaption?: string | null, showControls: any, autoplay: any, loop: any, display?: string | null, videoEmbedded?: { providerUid: string, provider: string, url: string } | null, videoInline?: { video?: { alt?: string | null, mp4Url?: string | null } | null } | null, posterImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

type ContentModules_CtaContactRecord_Fragment = { __typename: 'CtaContactRecord', id: any, contactGroup?: { title?: string | null, text?: { value: any } | null, teamPhoto?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null };

type ContentModules_CtaDefaultRecord_Fragment = { __typename: 'CtaDefaultRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null };

type ContentModules_CtaStoererRecord_Fragment = { __typename: 'CtaStoererRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null };

export type ContentModulesFragment = ContentModules_ContentAccordionRecord_Fragment | ContentModules_ContentDepartmentRecord_Fragment | ContentModules_ContentDownloadOverviewRecord_Fragment | ContentModules_ContentDownloadRecord_Fragment | ContentModules_ContentImageRecord_Fragment | ContentModules_ContentImagesliderRecord_Fragment | ContentModules_ContentImagetextRecord_Fragment | ContentModules_ContentNewsRecord_Fragment | ContentModules_ContentNewssliderRecord_Fragment | ContentModules_ContentRegistrationprocessRecord_Fragment | ContentModules_ContentTeacherDepartmentRecord_Fragment | ContentModules_ContentTeamRecord_Fragment | ContentModules_ContentTeammemberRecord_Fragment | ContentModules_ContentTeaserRecord_Fragment | ContentModules_ContentTestimonialRecord_Fragment | ContentModules_ContentTextRecord_Fragment | ContentModules_ContentVideoRecord_Fragment | ContentModules_CtaContactRecord_Fragment | ContentModules_CtaDefaultRecord_Fragment | ContentModules_CtaStoererRecord_Fragment;

type HeaderModulesPage_HeaderMediumRecord_Fragment = { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null };

type HeaderModulesPage_HeaderTextRecord_Fragment = { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null };

export type HeaderModulesPageFragment = HeaderModulesPage_HeaderMediumRecord_Fragment | HeaderModulesPage_HeaderTextRecord_Fragment;

type HeaderModulesNews_HeaderMediumRecord_Fragment = { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null };

type HeaderModulesNews_HeaderTextRecord_Fragment = { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null };

export type HeaderModulesNewsFragment = HeaderModulesNews_HeaderMediumRecord_Fragment | HeaderModulesNews_HeaderTextRecord_Fragment;

type HeaderModulesSchuelerblog_HeaderMediumRecord_Fragment = { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null };

type HeaderModulesSchuelerblog_HeaderTextRecord_Fragment = { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null };

export type HeaderModulesSchuelerblogFragment = HeaderModulesSchuelerblog_HeaderMediumRecord_Fragment | HeaderModulesSchuelerblog_HeaderTextRecord_Fragment;

export type HeaderMediumFragment = { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null };

export type HeaderTextFragment = { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null };

export type LinkFragment = { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null };

export type PageLinkFragment = { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null };

export type NewsLinkFragment = { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null };

export type AlumniPageLinkFragment = { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null };

export type PageMetaFragment = { id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> };

export type ResponsiveImageFragment = { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string };

export type TeamMemberFragment = { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null };

export type GetAlumniSettingsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAlumniSettingsQuery = { alumniNavigation?: { loginPage?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, registrationPage?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, entryPageAfterLogin?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, profilePage?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, passwordResetPage?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null };

export type GetFooterQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetFooterQuery = { footer?: { addressTitle?: string | null, information?: string | null, logo?: { alt?: string | null, url: string } | null, address?: { value: any } | null, sectionLinks: Array<{ id: any, title?: string | null, link: Array<{ emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> }>, socialLinks: Array<{ id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, icon?: { alt?: string | null, url: string } | null }>, legalInformationLinks: Array<{ id: any, emailUrl?: string | null, externalUrl?: string | null, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> } | null };

export type GetAlumniFooterQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAlumniFooterQuery = { footer?: { addressTitle?: string | null, information?: string | null, logo?: { alt?: string | null, url: string } | null, address?: { value: any } | null, sectionLinks: Array<{ id: any, title?: string | null, link: Array<{ emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> }>, socialLinks: Array<{ id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, icon?: { alt?: string | null, url: string } | null }>, legalInformationLinks: Array<{ id: any, emailUrl?: string | null, externalUrl?: string | null, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> } | null };

export type GetHeaderQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetHeaderQuery = { header?: { __typename: 'HeaderRecord', logo?: { alt?: string | null, url: string } | null, logoAlternative?: { alt?: string | null, url: string } | null } | null };

export type GetAlumniHeaderQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAlumniHeaderQuery = { header?: { __typename: 'AlumniHeaderRecord', home?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, logo?: { alt?: string | null, url: string } | null, logoAlternative?: { alt?: string | null, url: string } | null } | null };

export type GetMainNavigationQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetMainNavigationQuery = { navigation?: { navLinks: Array<{ id: any, subtree: Array<{ id: any, link?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }>, link?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> } | null };

export type GetAlumniNavigationQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAlumniNavigationQuery = { navigation?: { navLinks: Array<{ id: any, subtree: Array<{ id: any, link?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }>, link?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }>, loggedOutNavLinks: Array<{ id: any, subtree: Array<{ id: any, link?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }>, link?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> } | null };

export type NavLinkFragment = { id: any, link?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null };

export type ContentAccordionFragment = { title?: string | null, items: Array<{ id: any, title?: string | null, text?: { value: any } | null }> };

export type ContentAlumniEventListFragment = { __typename: 'ContentAlumniEventListRecord', showOnlyNextUpcomingEvent: any };

export type ContentAlumniLoginFragment = { __typename: 'ContentAlumniLoginRecord' };

export type ContentAlumniMemberListFragment = { __typename: 'ContentAlumniMemberListRecord' };

export type ContentAlumniPasswordResetFragment = { __typename: 'ContentAlumniPasswordResetRecord' };

export type ContentAlumniProfileFragment = { __typename: 'ContentAlumniProfileRecord' };

export type ContentAlumniRegisterFragment = { __typename: 'ContentAlumniRegisterRecord', confirmation: Array<{ __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null }> };

export type ContentDepartmentFragment = { title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }> };

export type ContentDownloadFragment = { title?: string | null, documents: Array<{ title?: string | null, filename: string, url: string }> };

export type ContentDownloadOverviewFragment = { title?: string | null, downloadCategories: Array<{ id: any, category?: string | null, _allReferencingDownloads: Array<{ id: any, documentTitle?: string | null, document?: { title?: string | null, filename: string, url: string } | null }> }> };

export type ContentImageFragment = { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

export type ContentImagesliderFragment = { images: Array<{ display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> };

export type ContentImagetextFragment = { title?: string | null, leadText?: string | null, imagePlacement?: string | null, text?: { value: any } | null, cta?: { id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

export type ContentNewsFragment = { title?: string | null, lead?: { value: any } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> };

export type ContentNewssliderFragment = { title?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'SchuelerblogRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> };

export type ContentPodcastFragment = { title?: string | null, description?: { value: any } | null, podcastsUrlList: Array<{ id: any, url?: string | null }> };

export type PodcastUrlFragment = { id: any, url?: string | null };

export type ContentRegistrationprocessFragment = { title?: string | null, steps: Array<{ title?: string | null, id: any, text?: { value: any } | null }> };

export type ContentTeacherDepartmentFragment = { title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }>, teachers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> };

export type ContentTeamFragment = { title?: string | null, teams: Array<{ id: any, name?: string | null }>, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> };

export type ContentTeammemberFragment = { title?: string | null, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> };

export type ContentTeaserFragment = { title?: string | null, lead?: { value: any } | null, teaser: Array<{ __typename: 'TeaserBigRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserHomeRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserSmallRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null }> };

export type ContentTestimonialFragment = { name?: string | null, title?: string | null, role?: string | null, statement?: { value: any } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

export type ContentTextFragment = { title?: string | null, content?: { value: any } | null };

export type ContentVideoFragment = { videoType: any, videoCaption?: string | null, showControls: any, autoplay: any, loop: any, display?: string | null, videoEmbedded?: { providerUid: string, provider: string, url: string } | null, videoInline?: { video?: { alt?: string | null, mp4Url?: string | null } | null } | null, posterImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

export type CtaContactFragment = { contactGroup?: { title?: string | null, text?: { value: any } | null, teamPhoto?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null };

export type CtaDefaultFragment = { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null };

export type CtaStoererFragment = { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null };

export type TeaserBigFragment = { __typename: 'TeaserBigRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null };

export type TeaserHomeFragment = { __typename: 'TeaserHomeRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null };

export type TeaserSmallFragment = { __typename: 'TeaserSmallRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null };

export type GetAlumniPageByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAlumniPageByTranslatedSlugQuery = { alumniPage?: { __typename: 'AlumniPageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, isPagePublic: any, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }>, headerModule?: { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null } | { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null } | null, contentModules: Array<{ __typename: 'ContentAccordionRecord', title?: string | null, items: Array<{ id: any, title?: string | null, text?: { value: any } | null }> } | { __typename: 'ContentAlumniEventListRecord', showOnlyNextUpcomingEvent: any } | { __typename: 'ContentAlumniLoginRecord' } | { __typename: 'ContentAlumniMemberListRecord' } | { __typename: 'ContentAlumniPasswordResetRecord' } | { __typename: 'ContentAlumniProfileRecord' } | { __typename: 'ContentAlumniRegisterRecord', confirmation: Array<{ __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null }> } | { __typename: 'ContentDownloadOverviewRecord', title?: string | null, downloadCategories: Array<{ id: any, category?: string | null, _allReferencingDownloads: Array<{ id: any, documentTitle?: string | null, document?: { title?: string | null, filename: string, url: string } | null }> }> } | { __typename: 'ContentDownloadRecord', title?: string | null, documents: Array<{ title?: string | null, filename: string, url: string }> } | { __typename: 'ContentImageRecord', display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentImagesliderRecord', images: Array<{ display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentImagetextRecord', title?: string | null, leadText?: string | null, imagePlacement?: string | null, text?: { value: any } | null, cta?: { id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentTeammemberRecord', title?: string | null, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeaserRecord', title?: string | null, lead?: { value: any } | null, teaser: Array<{ __typename: 'TeaserBigRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserHomeRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserSmallRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null }> } | { __typename: 'ContentTestimonialRecord', name?: string | null, title?: string | null, role?: string | null, statement?: { value: any } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentTextRecord', title?: string | null, content?: { value: any } | null } | { __typename: 'ContentVideoRecord', videoType: any, videoCaption?: string | null, showControls: any, autoplay: any, loop: any, display?: string | null, videoEmbedded?: { providerUid: string, provider: string, url: string } | null, videoInline?: { video?: { alt?: string | null, mp4Url?: string | null } | null } | null, posterImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'CtaDefaultRecord', link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'CtaStoererRecord', link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null }>, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null };

export type GetNewsByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetNewsByTranslatedSlugQuery = { news?: { __typename: 'NewsRecord', id: any, title?: string | null, slug?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }>, headerModule?: { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null } | { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null } | null, contentModules: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, items: Array<{ id: any, title?: string | null, text?: { value: any } | null }> } | { __typename: 'ContentDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }> } | { __typename: 'ContentDownloadOverviewRecord', id: any, title?: string | null, downloadCategories: Array<{ id: any, category?: string | null, _allReferencingDownloads: Array<{ id: any, documentTitle?: string | null, document?: { title?: string | null, filename: string, url: string } | null }> }> } | { __typename: 'ContentDownloadRecord', id: any, title?: string | null, documents: Array<{ title?: string | null, filename: string, url: string }> } | { __typename: 'ContentImageRecord', id: any, display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentImagesliderRecord', id: any, images: Array<{ display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentImagetextRecord', id: any, title?: string | null, leadText?: string | null, imagePlacement?: string | null, text?: { value: any } | null, cta?: { id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentNewsRecord', id: any, title?: string | null, lead?: { value: any } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentNewssliderRecord', id: any, title?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'SchuelerblogRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentRegistrationprocessRecord', id: any, title?: string | null, steps: Array<{ title?: string | null, id: any, text?: { value: any } | null }> } | { __typename: 'ContentTeacherDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }>, teachers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeamRecord', id: any, title?: string | null, teams: Array<{ id: any, name?: string | null }>, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeammemberRecord', id: any, title?: string | null, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeaserRecord', id: any, title?: string | null, lead?: { value: any } | null, teaser: Array<{ __typename: 'TeaserBigRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserHomeRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserSmallRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null }> } | { __typename: 'ContentTestimonialRecord', id: any, name?: string | null, title?: string | null, role?: string | null, statement?: { value: any } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null } | { __typename: 'ContentVideoRecord', id: any, videoType: any, videoCaption?: string | null, showControls: any, autoplay: any, loop: any, display?: string | null, videoEmbedded?: { providerUid: string, provider: string, url: string } | null, videoInline?: { video?: { alt?: string | null, mp4Url?: string | null } | null } | null, posterImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'CtaContactRecord', id: any, contactGroup?: { title?: string | null, text?: { value: any } | null, teamPhoto?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null } | { __typename: 'CtaDefaultRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'CtaStoererRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null }>, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null };

export type NewsTeaserItemFragment = { __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

export type GetPageByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetPageByTranslatedSlugQuery = { page?: { __typename: 'PageRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, canonicalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, headerModule?: { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null } | { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null } | null, contentModules: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, items: Array<{ id: any, title?: string | null, text?: { value: any } | null }> } | { __typename: 'ContentDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }> } | { __typename: 'ContentDownloadOverviewRecord', id: any, title?: string | null, downloadCategories: Array<{ id: any, category?: string | null, _allReferencingDownloads: Array<{ id: any, documentTitle?: string | null, document?: { title?: string | null, filename: string, url: string } | null }> }> } | { __typename: 'ContentDownloadRecord', id: any, title?: string | null, documents: Array<{ title?: string | null, filename: string, url: string }> } | { __typename: 'ContentImageRecord', id: any, display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentImagesliderRecord', id: any, images: Array<{ display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentImagetextRecord', id: any, title?: string | null, leadText?: string | null, imagePlacement?: string | null, text?: { value: any } | null, cta?: { id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentNewsRecord', id: any, title?: string | null, lead?: { value: any } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentNewssliderRecord', id: any, title?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'SchuelerblogRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentRegistrationprocessRecord', id: any, title?: string | null, steps: Array<{ title?: string | null, id: any, text?: { value: any } | null }> } | { __typename: 'ContentTeacherDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }>, teachers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeamRecord', id: any, title?: string | null, teams: Array<{ id: any, name?: string | null }>, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeammemberRecord', id: any, title?: string | null, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeaserRecord', id: any, title?: string | null, lead?: { value: any } | null, teaser: Array<{ __typename: 'TeaserBigRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserHomeRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserSmallRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null }> } | { __typename: 'ContentTestimonialRecord', id: any, name?: string | null, title?: string | null, role?: string | null, statement?: { value: any } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null } | { __typename: 'ContentVideoRecord', id: any, videoType: any, videoCaption?: string | null, showControls: any, autoplay: any, loop: any, display?: string | null, videoEmbedded?: { providerUid: string, provider: string, url: string } | null, videoInline?: { video?: { alt?: string | null, mp4Url?: string | null } | null } | null, posterImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'CtaContactRecord', id: any, contactGroup?: { title?: string | null, text?: { value: any } | null, teamPhoto?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null } | { __typename: 'CtaDefaultRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'CtaStoererRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null }>, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type GetSchuelerblogByTranslatedSlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetSchuelerblogByTranslatedSlugQuery = { schuelerblog?: { __typename: 'SchuelerblogRecord', id: any, title?: string | null, slug?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }>, headerModule?: { __typename: 'HeaderMediumRecord', id: any, title?: string | null, lead?: { value: any } | null, media?: { id: any, url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null, video?: { alt?: string | null, mp4Url?: string | null } | null } | null, stoerer?: { link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null } | null } | { __typename: 'HeaderTextRecord', id: any, title?: string | null, lead?: { value: any } | null } | null, contentModules: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, items: Array<{ id: any, title?: string | null, text?: { value: any } | null }> } | { __typename: 'ContentDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }> } | { __typename: 'ContentDownloadOverviewRecord', id: any, title?: string | null, downloadCategories: Array<{ id: any, category?: string | null, _allReferencingDownloads: Array<{ id: any, documentTitle?: string | null, document?: { title?: string | null, filename: string, url: string } | null }> }> } | { __typename: 'ContentDownloadRecord', id: any, title?: string | null, documents: Array<{ title?: string | null, filename: string, url: string }> } | { __typename: 'ContentImageRecord', id: any, display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentImagesliderRecord', id: any, images: Array<{ display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentImagetextRecord', id: any, title?: string | null, leadText?: string | null, imagePlacement?: string | null, text?: { value: any } | null, cta?: { id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentNewsRecord', id: any, title?: string | null, lead?: { value: any } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentNewssliderRecord', id: any, title?: string | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, news: Array<{ __typename: 'NewsRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'SchuelerblogRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null }> } | { __typename: 'ContentPodcastRecord', id: any, title?: string | null, description?: { value: any } | null, podcastsUrlList: Array<{ id: any, url?: string | null }> } | { __typename: 'ContentRegistrationprocessRecord', id: any, title?: string | null, steps: Array<{ title?: string | null, id: any, text?: { value: any } | null }> } | { __typename: 'ContentTeacherDepartmentRecord', id: any, title?: string | null, departments: Array<{ id: any, name?: string | null, description?: { value: any } | null, image?: { display?: string | null, caption?: string | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null }>, teachers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeamRecord', id: any, title?: string | null, teams: Array<{ id: any, name?: string | null }>, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeammemberRecord', id: any, title?: string | null, teamMembers: Array<{ id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null }> } | { __typename: 'ContentTeaserRecord', id: any, title?: string | null, lead?: { value: any } | null, teaser: Array<{ __typename: 'TeaserBigRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserHomeRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'TeaserSmallRecord', id: any, title?: string | null, lead?: { value: any } | null, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null }> } | { __typename: 'ContentTestimonialRecord', id: any, name?: string | null, title?: string | null, role?: string | null, statement?: { value: any } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null } | { __typename: 'ContentVideoRecord', id: any, videoType: any, videoCaption?: string | null, showControls: any, autoplay: any, loop: any, display?: string | null, videoEmbedded?: { providerUid: string, provider: string, url: string } | null, videoInline?: { video?: { alt?: string | null, mp4Url?: string | null } | null } | null, posterImage?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | { __typename: 'CtaContactRecord', id: any, contactGroup?: { title?: string | null, text?: { value: any } | null, teamPhoto?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null } | null } | { __typename: 'CtaDefaultRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null } | { __typename: 'CtaStoererRecord', id: any, link?: { emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'AlumniPageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | { __typename: 'NewsRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | { __typename: 'PageRecord', id: any, title?: string | null, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, parent?: { _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, color?: { hex: string } | null }>, _allTranslatedSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null };

export type SchuelerblogTeaserItemFragment = { __typename: 'SchuelerblogRecord', id: any, slug?: string | null, title?: string | null, translatedSlug?: string | null, date?: any | null, author?: { id: any, firstname?: string | null, lastname?: string | null, role?: string | null, eMail?: string | null, phone?: string | null, author: any, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null, teams: Array<{ id: any, name?: string | null }>, departments: Array<{ id: any, name?: string | null }>, description?: { value: any } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { alt?: string | null, src: string, srcSet: string, webpSrcSet: string, aspectRatio: any, sizes: string } | null } | null };

export const ContentAccordionFragmentDoc = gql`
    fragment ContentAccordion on ContentAccordionRecord {
  title
  items {
    id
    text {
      value
    }
    title
  }
}
    `;
export const ContentDownloadFragmentDoc = gql`
    fragment ContentDownload on ContentDownloadRecord {
  title
  documents {
    title
    filename
    url
  }
}
    `;
export const ContentDownloadOverviewFragmentDoc = gql`
    fragment ContentDownloadOverview on ContentDownloadOverviewRecord {
  title
  downloadCategories {
    id
    category
    _allReferencingDownloads {
      id
      documentTitle
      document {
        title
        filename
        url
      }
    }
  }
}
    `;
export const ResponsiveImageFragmentDoc = gql`
    fragment ResponsiveImage on ResponsiveImage {
  alt
  src
  srcSet
  webpSrcSet
  aspectRatio
  sizes
}
    `;
export const ContentImageFragmentDoc = gql`
    fragment ContentImage on ContentImageRecord {
  image {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "16:9", fit: crop}) {
      ...ResponsiveImage
    }
  }
  display
  caption
}
    `;
export const ContentImagesliderFragmentDoc = gql`
    fragment ContentImageslider on ContentImagesliderRecord {
  images {
    ...ContentImage
  }
}
    `;
export const ContentVideoFragmentDoc = gql`
    fragment ContentVideo on ContentVideoRecord {
  videoType
  videoEmbedded {
    providerUid
    provider
    url
  }
  videoInline {
    video {
      alt
      mp4Url
    }
  }
  videoCaption
  posterImage {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "16:9", fit: crop}) {
      ...ResponsiveImage
    }
  }
  showControls
  autoplay
  loop
  display
}
    `;
export const ContentTextFragmentDoc = gql`
    fragment ContentText on ContentTextRecord {
  title
  content {
    value
  }
}
    `;
export const ContentTestimonialFragmentDoc = gql`
    fragment ContentTestimonial on ContentTestimonialRecord {
  name
  title
  statement {
    value
  }
  role
  image {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "1:1", fit: crop}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on TeamMemberRecord {
  id
  image {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "1:1", fit: crop}) {
      ...ResponsiveImage
    }
  }
  firstname
  lastname
  role
  teams {
    id
    name
  }
  departments {
    id
    name
  }
  eMail
  phone
  description {
    value
  }
  author
}
    `;
export const ContentTeammemberFragmentDoc = gql`
    fragment ContentTeammember on ContentTeammemberRecord {
  title
  teamMembers {
    ...TeamMember
  }
}
    `;
export const NewsTeaserItemFragmentDoc = gql`
    fragment NewsTeaserItem on NewsRecord {
  __typename
  id
  slug
  title
  translatedSlug
  author {
    ...TeamMember
  }
  date
  image {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "4:3", fit: crop}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const ContentNewsFragmentDoc = gql`
    fragment ContentNews on ContentNewsRecord {
  title
  lead {
    value
  }
  news {
    ...NewsTeaserItem
  }
}
    `;
export const PageLinkFragmentDoc = gql`
    fragment PageLink on PageRecord {
  __typename
  id
  title
  _allTranslatedSlugLocales {
    value
    locale
  }
  parent {
    _allTranslatedSlugLocales {
      value
      locale
    }
  }
}
    `;
export const NewsLinkFragmentDoc = gql`
    fragment NewsLink on NewsRecord {
  __typename
  id
  title
  _allTranslatedSlugLocales {
    value
    locale
  }
}
    `;
export const AlumniPageLinkFragmentDoc = gql`
    fragment AlumniPageLink on AlumniPageRecord {
  __typename
  id
  title
  _allTranslatedSlugLocales {
    value
    locale
  }
  parent {
    _allTranslatedSlugLocales {
      value
      locale
    }
  }
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on LinkRecord {
  emailUrl
  externalUrl
  id
  internalUrl {
    ...PageLink
    ...NewsLink
    ...AlumniPageLink
  }
  linkText
  linkType
  openLinkInNewWindow
}
    `;
export const SchuelerblogTeaserItemFragmentDoc = gql`
    fragment SchuelerblogTeaserItem on SchuelerblogRecord {
  __typename
  id
  slug
  title
  translatedSlug
  author {
    ...TeamMember
  }
  date
  image {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "4:3", fit: crop}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const ContentNewssliderFragmentDoc = gql`
    fragment ContentNewsslider on ContentNewssliderRecord {
  title
  link {
    ...Link
  }
  news {
    __typename
    ...NewsTeaserItem
    ...SchuelerblogTeaserItem
  }
}
    `;
export const ContentImagetextFragmentDoc = gql`
    fragment ContentImagetext on ContentImagetextRecord {
  title
  leadText
  text {
    value
  }
  cta {
    id
    link {
      ...Link
    }
  }
  image {
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "4:3", fit: crop}) {
      ...ResponsiveImage
    }
  }
  imagePlacement
}
    `;
export const ContentRegistrationprocessFragmentDoc = gql`
    fragment ContentRegistrationprocess on ContentRegistrationprocessRecord {
  title
  steps {
    title
    id
    text {
      value
    }
  }
}
    `;
export const CtaContactFragmentDoc = gql`
    fragment CtaContact on CtaContactRecord {
  contactGroup {
    title
    text {
      value
    }
    teamPhoto {
      url
      alt
      mimeType
      responsiveImage(imgixParams: {ar: "1:1", fit: crop}) {
        ...ResponsiveImage
      }
    }
  }
}
    `;
export const TeaserSmallFragmentDoc = gql`
    fragment TeaserSmall on TeaserSmallRecord {
  __typename
  id
  title
  lead {
    value
  }
  link {
    ...Link
  }
}
    `;
export const TeaserBigFragmentDoc = gql`
    fragment TeaserBig on TeaserBigRecord {
  __typename
  id
  title
  lead {
    value
  }
  link {
    ...Link
  }
}
    `;
export const TeaserHomeFragmentDoc = gql`
    fragment TeaserHome on TeaserHomeRecord {
  __typename
  id
  title
  lead {
    value
  }
  link {
    ...Link
  }
}
    `;
export const ContentTeaserFragmentDoc = gql`
    fragment ContentTeaser on ContentTeaserRecord {
  title
  lead {
    value
  }
  teaser {
    ...TeaserSmall
    ...TeaserBig
    ...TeaserHome
  }
}
    `;
export const CtaStoererFragmentDoc = gql`
    fragment CtaStoerer on CtaStoererRecord {
  link {
    ...Link
  }
  color {
    hex
  }
}
    `;
export const CtaDefaultFragmentDoc = gql`
    fragment CtaDefault on CtaDefaultRecord {
  link {
    ...Link
  }
}
    `;
export const ContentDepartmentFragmentDoc = gql`
    fragment ContentDepartment on ContentDepartmentRecord {
  title
  departments {
    id
    name
    description {
      value
    }
    image {
      ...ContentImage
    }
  }
}
    `;
export const ContentTeacherDepartmentFragmentDoc = gql`
    fragment ContentTeacherDepartment on ContentTeacherDepartmentRecord {
  title
  departments {
    id
    name
    description {
      value
    }
    image {
      ...ContentImage
    }
  }
  teachers {
    ...TeamMember
  }
}
    `;
export const ContentTeamFragmentDoc = gql`
    fragment ContentTeam on ContentTeamRecord {
  title
  teams {
    id
    name
  }
  teamMembers {
    ...TeamMember
  }
}
    `;
export const ContentModulesFragmentDoc = gql`
    fragment ContentModules on PageModelContentModulesField {
  ... on ContentAccordionRecord {
    id
    __typename
    ...ContentAccordion
  }
  ... on ContentDownloadRecord {
    id
    __typename
    ...ContentDownload
  }
  ... on ContentDownloadOverviewRecord {
    id
    __typename
    ...ContentDownloadOverview
  }
  ... on ContentImagesliderRecord {
    id
    __typename
    ...ContentImageslider
  }
  ... on ContentVideoRecord {
    id
    __typename
    ...ContentVideo
  }
  ... on ContentTextRecord {
    id
    __typename
    ...ContentText
  }
  ... on ContentTestimonialRecord {
    id
    __typename
    ...ContentTestimonial
  }
  ... on ContentTeammemberRecord {
    id
    __typename
    ...ContentTeammember
  }
  ... on ContentNewsRecord {
    id
    __typename
    ...ContentNews
  }
  ... on ContentNewssliderRecord {
    id
    __typename
    ...ContentNewsslider
  }
  ... on ContentImagetextRecord {
    id
    __typename
    ...ContentImagetext
  }
  ... on ContentImageRecord {
    id
    __typename
    ...ContentImage
  }
  ... on ContentRegistrationprocessRecord {
    id
    __typename
    ...ContentRegistrationprocess
  }
  ... on ContentVideoRecord {
    id
    __typename
    ...ContentVideo
  }
  ... on CtaContactRecord {
    id
    __typename
    ...CtaContact
  }
  ... on ContentTeaserRecord {
    id
    __typename
    ...ContentTeaser
  }
  ... on CtaStoererRecord {
    id
    __typename
    ...CtaStoerer
  }
  ... on CtaDefaultRecord {
    id
    __typename
    ...CtaDefault
  }
  ... on ContentDepartmentRecord {
    id
    __typename
    ...ContentDepartment
  }
  ... on ContentTeacherDepartmentRecord {
    id
    __typename
    ...ContentTeacherDepartment
  }
  ... on ContentTeamRecord {
    id
    __typename
    ...ContentTeam
  }
}
    `;
export const HeaderMediumFragmentDoc = gql`
    fragment HeaderMedium on HeaderMediumRecord {
  id
  __typename
  title
  lead {
    value
  }
  media {
    id
    url
    alt
    mimeType
    responsiveImage(imgixParams: {ar: "16:9", fit: crop}) {
      ...ResponsiveImage
    }
    video {
      alt
      mp4Url
    }
  }
  stoerer {
    ...CtaStoerer
  }
}
    `;
export const HeaderTextFragmentDoc = gql`
    fragment HeaderText on HeaderTextRecord {
  id
  __typename
  lead {
    value
  }
  title
}
    `;
export const HeaderModulesPageFragmentDoc = gql`
    fragment HeaderModulesPage on PageModelHeaderModuleField {
  ...HeaderMedium
  ...HeaderText
}
    `;
export const HeaderModulesNewsFragmentDoc = gql`
    fragment HeaderModulesNews on NewsModelHeaderModuleField {
  ...HeaderMedium
  ...HeaderText
}
    `;
export const HeaderModulesSchuelerblogFragmentDoc = gql`
    fragment HeaderModulesSchuelerblog on SchuelerblogModelHeaderModuleField {
  ...HeaderMedium
  ...HeaderText
}
    `;
export const PageMetaFragmentDoc = gql`
    fragment PageMeta on PageRecord {
  id
  slug
  title
  translatedSlug
  _seoMetaTags {
    attributes
    content
    tag
  }
}
    `;
export const NavLinkFragmentDoc = gql`
    fragment NavLink on NavigationLinkRecord {
  id
  link {
    ...PageLink
    ...NewsLink
    ...AlumniPageLink
  }
}
    `;
export const ContentAlumniEventListFragmentDoc = gql`
    fragment ContentAlumniEventList on ContentAlumniEventListRecord {
  __typename
  showOnlyNextUpcomingEvent
}
    `;
export const ContentAlumniLoginFragmentDoc = gql`
    fragment ContentAlumniLogin on ContentAlumniLoginRecord {
  __typename
}
    `;
export const ContentAlumniMemberListFragmentDoc = gql`
    fragment ContentAlumniMemberList on ContentAlumniMemberListRecord {
  __typename
}
    `;
export const ContentAlumniPasswordResetFragmentDoc = gql`
    fragment ContentAlumniPasswordReset on ContentAlumniPasswordResetRecord {
  __typename
}
    `;
export const ContentAlumniProfileFragmentDoc = gql`
    fragment ContentAlumniProfile on ContentAlumniProfileRecord {
  __typename
}
    `;
export const ContentAlumniRegisterFragmentDoc = gql`
    fragment ContentAlumniRegister on ContentAlumniRegisterRecord {
  __typename
  confirmation {
    __typename
    id
    title
    content {
      value
    }
  }
}
    `;
export const PodcastUrlFragmentDoc = gql`
    fragment PodcastUrl on PodcastUrlRecord {
  id
  url
}
    `;
export const ContentPodcastFragmentDoc = gql`
    fragment ContentPodcast on ContentPodcastRecord {
  title
  description {
    value
  }
  podcastsUrlList {
    ...PodcastUrl
  }
}
    `;
export const GetAlumniSettingsDocument = gql`
    query GetAlumniSettings($locale: SiteLocale) {
  alumniNavigation(locale: $locale) {
    loginPage {
      ...AlumniPageLink
    }
    registrationPage {
      ...AlumniPageLink
    }
    entryPageAfterLogin {
      ...AlumniPageLink
    }
    profilePage {
      ...AlumniPageLink
    }
    passwordResetPage {
      ...AlumniPageLink
    }
  }
}
    ${AlumniPageLinkFragmentDoc}`;
export const GetFooterDocument = gql`
    query GetFooter($locale: SiteLocale) {
  footer(locale: $locale) {
    logo {
      alt
      url
    }
    addressTitle
    address {
      value
    }
    sectionLinks {
      id
      title
      link {
        ...Link
      }
    }
    socialLinks {
      id
      link {
        ...Link
      }
      icon {
        alt
        url
      }
    }
    legalInformationLinks {
      id
      ...Link
    }
    information
  }
}
    ${LinkFragmentDoc}
${PageLinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}`;
export const GetAlumniFooterDocument = gql`
    query GetAlumniFooter($locale: SiteLocale) {
  footer: alumniFooter(locale: $locale) {
    logo {
      alt
      url
    }
    addressTitle
    address {
      value
    }
    sectionLinks {
      id
      title
      link {
        ...Link
      }
    }
    socialLinks {
      id
      link {
        ...Link
      }
      icon {
        alt
        url
      }
    }
    legalInformationLinks {
      id
      ...Link
    }
    information
  }
}
    ${LinkFragmentDoc}
${PageLinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}`;
export const GetHeaderDocument = gql`
    query GetHeader($locale: SiteLocale) {
  header(locale: $locale) {
    __typename
    logo {
      alt
      url
    }
    logoAlternative {
      alt
      url
    }
  }
}
    `;
export const GetAlumniHeaderDocument = gql`
    query GetAlumniHeader($locale: SiteLocale) {
  header: alumniHeader(locale: $locale) {
    __typename
    home {
      ...AlumniPageLink
    }
    logo {
      alt
      url
    }
    logoAlternative {
      alt
      url
    }
  }
}
    ${AlumniPageLinkFragmentDoc}`;
export const GetMainNavigationDocument = gql`
    query GetMainNavigation($locale: SiteLocale) {
  navigation: mainNavigation(locale: $locale) {
    navLinks {
      ...NavLink
      subtree {
        ...NavLink
      }
    }
  }
}
    ${NavLinkFragmentDoc}
${PageLinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}`;
export const GetAlumniNavigationDocument = gql`
    query GetAlumniNavigation($locale: SiteLocale) {
  navigation: alumniNavigation(locale: $locale) {
    navLinks {
      ...NavLink
      subtree {
        ...NavLink
      }
    }
    loggedOutNavLinks {
      ...NavLink
      subtree {
        ...NavLink
      }
    }
  }
}
    ${NavLinkFragmentDoc}
${PageLinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}`;
export const GetAlumniPageByTranslatedSlugDocument = gql`
    query GetAlumniPageByTranslatedSlug($slug: String, $locale: SiteLocale) {
  alumniPage(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    __typename
    id
    slug
    title
    translatedSlug
    isPagePublic
    _seoMetaTags {
      attributes
      content
      tag
    }
    headerModule {
      ...HeaderModulesPage
    }
    contentModules {
      __typename
      ...ContentAccordion
      ...ContentDownload
      ...ContentDownloadOverview
      ...ContentImage
      ...ContentImageslider
      ...ContentImagetext
      ...ContentTeaser
      ...ContentText
      ...ContentTestimonial
      ...ContentVideo
      ...ContentTeammember
      ...CtaDefault
      ...CtaStoerer
      ...ContentAlumniLogin
      ...ContentAlumniRegister
      ...ContentAlumniPasswordReset
      ...ContentAlumniProfile
      ...ContentAlumniMemberList
      ...ContentAlumniEventList
    }
    _allTranslatedSlugLocales {
      value
      locale
    }
    parent {
      _allTranslatedSlugLocales {
        value
        locale
      }
    }
  }
}
    ${HeaderModulesPageFragmentDoc}
${HeaderMediumFragmentDoc}
${ResponsiveImageFragmentDoc}
${CtaStoererFragmentDoc}
${LinkFragmentDoc}
${PageLinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}
${HeaderTextFragmentDoc}
${ContentAccordionFragmentDoc}
${ContentDownloadFragmentDoc}
${ContentDownloadOverviewFragmentDoc}
${ContentImageFragmentDoc}
${ContentImagesliderFragmentDoc}
${ContentImagetextFragmentDoc}
${ContentTeaserFragmentDoc}
${TeaserSmallFragmentDoc}
${TeaserBigFragmentDoc}
${TeaserHomeFragmentDoc}
${ContentTextFragmentDoc}
${ContentTestimonialFragmentDoc}
${ContentVideoFragmentDoc}
${ContentTeammemberFragmentDoc}
${TeamMemberFragmentDoc}
${CtaDefaultFragmentDoc}
${ContentAlumniLoginFragmentDoc}
${ContentAlumniRegisterFragmentDoc}
${ContentAlumniPasswordResetFragmentDoc}
${ContentAlumniProfileFragmentDoc}
${ContentAlumniMemberListFragmentDoc}
${ContentAlumniEventListFragmentDoc}`;
export const GetNewsByTranslatedSlugDocument = gql`
    query GetNewsByTranslatedSlug($slug: String, $locale: SiteLocale) {
  news(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    __typename
    id
    title
    slug
    translatedSlug
    author {
      ...TeamMember
    }
    date
    image {
      url
      alt
      mimeType
      responsiveImage(imgixParams: {ar: "16:9", fit: crop}) {
        ...ResponsiveImage
      }
    }
    _seoMetaTags {
      attributes
      content
      tag
    }
    headerModule {
      ...HeaderModulesNews
    }
    contentModules {
      ...ContentModules
    }
    _allTranslatedSlugLocales {
      value
      locale
    }
  }
}
    ${TeamMemberFragmentDoc}
${ResponsiveImageFragmentDoc}
${HeaderModulesNewsFragmentDoc}
${HeaderMediumFragmentDoc}
${CtaStoererFragmentDoc}
${LinkFragmentDoc}
${PageLinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}
${HeaderTextFragmentDoc}
${ContentModulesFragmentDoc}
${ContentAccordionFragmentDoc}
${ContentDownloadFragmentDoc}
${ContentDownloadOverviewFragmentDoc}
${ContentImagesliderFragmentDoc}
${ContentImageFragmentDoc}
${ContentVideoFragmentDoc}
${ContentTextFragmentDoc}
${ContentTestimonialFragmentDoc}
${ContentTeammemberFragmentDoc}
${ContentNewsFragmentDoc}
${NewsTeaserItemFragmentDoc}
${ContentNewssliderFragmentDoc}
${SchuelerblogTeaserItemFragmentDoc}
${ContentImagetextFragmentDoc}
${ContentRegistrationprocessFragmentDoc}
${CtaContactFragmentDoc}
${ContentTeaserFragmentDoc}
${TeaserSmallFragmentDoc}
${TeaserBigFragmentDoc}
${TeaserHomeFragmentDoc}
${CtaDefaultFragmentDoc}
${ContentDepartmentFragmentDoc}
${ContentTeacherDepartmentFragmentDoc}
${ContentTeamFragmentDoc}`;
export const GetPageByTranslatedSlugDocument = gql`
    query GetPageByTranslatedSlug($slug: String, $locale: SiteLocale) {
  page(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    __typename
    ...PageMeta
    canonicalUrl {
      ...PageLink
    }
    headerModule {
      ...HeaderModulesPage
    }
    contentModules {
      ...ContentModules
    }
    _allTranslatedSlugLocales {
      value
      locale
    }
    parent {
      _allTranslatedSlugLocales {
        value
        locale
      }
    }
  }
}
    ${PageMetaFragmentDoc}
${PageLinkFragmentDoc}
${HeaderModulesPageFragmentDoc}
${HeaderMediumFragmentDoc}
${ResponsiveImageFragmentDoc}
${CtaStoererFragmentDoc}
${LinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}
${HeaderTextFragmentDoc}
${ContentModulesFragmentDoc}
${ContentAccordionFragmentDoc}
${ContentDownloadFragmentDoc}
${ContentDownloadOverviewFragmentDoc}
${ContentImagesliderFragmentDoc}
${ContentImageFragmentDoc}
${ContentVideoFragmentDoc}
${ContentTextFragmentDoc}
${ContentTestimonialFragmentDoc}
${ContentTeammemberFragmentDoc}
${TeamMemberFragmentDoc}
${ContentNewsFragmentDoc}
${NewsTeaserItemFragmentDoc}
${ContentNewssliderFragmentDoc}
${SchuelerblogTeaserItemFragmentDoc}
${ContentImagetextFragmentDoc}
${ContentRegistrationprocessFragmentDoc}
${CtaContactFragmentDoc}
${ContentTeaserFragmentDoc}
${TeaserSmallFragmentDoc}
${TeaserBigFragmentDoc}
${TeaserHomeFragmentDoc}
${CtaDefaultFragmentDoc}
${ContentDepartmentFragmentDoc}
${ContentTeacherDepartmentFragmentDoc}
${ContentTeamFragmentDoc}`;
export const GetSchuelerblogByTranslatedSlugDocument = gql`
    query GetSchuelerblogByTranslatedSlug($slug: String, $locale: SiteLocale) {
  schuelerblog(locale: $locale, filter: {translatedSlug: {eq: $slug}}) {
    __typename
    id
    title
    slug
    translatedSlug
    author {
      ...TeamMember
    }
    date
    image {
      url
      alt
      mimeType
      responsiveImage(imgixParams: {ar: "16:9", fit: crop}) {
        ...ResponsiveImage
      }
    }
    _seoMetaTags {
      attributes
      content
      tag
    }
    headerModule {
      ...HeaderModulesSchuelerblog
    }
    contentModules {
      ...ContentModules
      ... on ContentPodcastRecord {
        id
        __typename
        ...ContentPodcast
      }
    }
    _allTranslatedSlugLocales {
      value
      locale
    }
  }
}
    ${TeamMemberFragmentDoc}
${ResponsiveImageFragmentDoc}
${HeaderModulesSchuelerblogFragmentDoc}
${HeaderMediumFragmentDoc}
${CtaStoererFragmentDoc}
${LinkFragmentDoc}
${PageLinkFragmentDoc}
${NewsLinkFragmentDoc}
${AlumniPageLinkFragmentDoc}
${HeaderTextFragmentDoc}
${ContentModulesFragmentDoc}
${ContentAccordionFragmentDoc}
${ContentDownloadFragmentDoc}
${ContentDownloadOverviewFragmentDoc}
${ContentImagesliderFragmentDoc}
${ContentImageFragmentDoc}
${ContentVideoFragmentDoc}
${ContentTextFragmentDoc}
${ContentTestimonialFragmentDoc}
${ContentTeammemberFragmentDoc}
${ContentNewsFragmentDoc}
${NewsTeaserItemFragmentDoc}
${ContentNewssliderFragmentDoc}
${SchuelerblogTeaserItemFragmentDoc}
${ContentImagetextFragmentDoc}
${ContentRegistrationprocessFragmentDoc}
${CtaContactFragmentDoc}
${ContentTeaserFragmentDoc}
${TeaserSmallFragmentDoc}
${TeaserBigFragmentDoc}
${TeaserHomeFragmentDoc}
${CtaDefaultFragmentDoc}
${ContentDepartmentFragmentDoc}
${ContentTeacherDepartmentFragmentDoc}
${ContentTeamFragmentDoc}
${ContentPodcastFragmentDoc}
${PodcastUrlFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetAlumniSettings(variables?: GetAlumniSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlumniSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlumniSettingsQuery>({ document: GetAlumniSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlumniSettings', 'query', variables);
    },
    GetFooter(variables?: GetFooterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetFooterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFooterQuery>({ document: GetFooterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetFooter', 'query', variables);
    },
    GetAlumniFooter(variables?: GetAlumniFooterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlumniFooterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlumniFooterQuery>({ document: GetAlumniFooterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlumniFooter', 'query', variables);
    },
    GetHeader(variables?: GetHeaderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetHeaderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHeaderQuery>({ document: GetHeaderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetHeader', 'query', variables);
    },
    GetAlumniHeader(variables?: GetAlumniHeaderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlumniHeaderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlumniHeaderQuery>({ document: GetAlumniHeaderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlumniHeader', 'query', variables);
    },
    GetMainNavigation(variables?: GetMainNavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetMainNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMainNavigationQuery>({ document: GetMainNavigationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetMainNavigation', 'query', variables);
    },
    GetAlumniNavigation(variables?: GetAlumniNavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlumniNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlumniNavigationQuery>({ document: GetAlumniNavigationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlumniNavigation', 'query', variables);
    },
    GetAlumniPageByTranslatedSlug(variables?: GetAlumniPageByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlumniPageByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlumniPageByTranslatedSlugQuery>({ document: GetAlumniPageByTranslatedSlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlumniPageByTranslatedSlug', 'query', variables);
    },
    GetNewsByTranslatedSlug(variables?: GetNewsByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetNewsByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNewsByTranslatedSlugQuery>({ document: GetNewsByTranslatedSlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetNewsByTranslatedSlug', 'query', variables);
    },
    GetPageByTranslatedSlug(variables?: GetPageByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageByTranslatedSlugQuery>({ document: GetPageByTranslatedSlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetPageByTranslatedSlug', 'query', variables);
    },
    GetSchuelerblogByTranslatedSlug(variables?: GetSchuelerblogByTranslatedSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSchuelerblogByTranslatedSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSchuelerblogByTranslatedSlugQuery>({ document: GetSchuelerblogByTranslatedSlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetSchuelerblogByTranslatedSlug', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;